import createDOMSubscription from './createDOMSubscription';
import connectDOMNodes from './connectDOMNodes';

export default function render(renderer) {
  if (!renderer.updateSubscription) {
    connectDOMNodes(renderer);

    renderer.updateSubscription = createDOMSubscription(renderer.nodes);
    renderer.subscribe(renderer.updateSubscription);
  }
}